import { BasePageProps, BasePageState, basePageInitialState } from '../BasePage'

import { store } from '../../redux/store'

import { createReducer, createAction } from '@reduxjs/toolkit'

export interface VintageBikeProps extends BasePageProps {}

type VintageBikeState = {
    targa: string | undefined
    targaError: string | undefined
}

export type VintageBikePageState = VintageBikeState & BasePageState

export const vintagebikeInitialState : VintageBikePageState = {
    ...basePageInitialState,
    ...{
        targa: undefined,
        targaError: undefined,
    }
}

export const vintagebikeUpdate = createAction<VintageBikePageState>('vintagebike/update')

export const vintagebikeReducer = createReducer ( 
    vintagebikeInitialState,
    (builder) => {
        builder.addCase(vintagebikeUpdate, (state, action) => {
            return action.payload as VintageBikePageState
        })
    }
)

export type VintageBikeRootState = ReturnType<typeof store.getState>
export type VintageBikeDispatch = typeof store.dispatch